import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import type { ContactDetail } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/enums";

export default function createContactsTrackingService(track: TrackFn) {
    return {
        trackSearchByContactName() {
            track("contacts options", "apply enter", "apply search/contact name search");
        },
        trackContactsResultsPageIncreasedTwice() {
            track("contacts table", "click next", "next next page/next 1 to 2/next 2 to 3");
        },
        trackEmployeeProfilesDropdownOpened() {
            track("contacts options", "open employee profile DD", "expand filter/employee profile");
        },
        trackEmployeeProfileSelected(isShared: boolean) {
            if (isShared) {
                track("contacts options", "select profile", "suggested profiles");
            } else {
                track("contacts options", "select profile", "my profiles");
            }
        },
        trackEmployeeProfileEditClicked(profileName: string) {
            track("contacts options", "edit profile", `edit employee profile/${profileName}`);
        },
        trackEmployeeProfileCreateClicked() {
            track("contacts options", "create new", "create employee profile");
        },
        trackEmployeeLocationDropdownOpened() {
            track("contacts options", "open employee location DD", "expand filter/employee location");
        },
        trackEmployeeLocationSelected() {
            track("contacts options", "change employee location", "apply location");
        },
        trackContactDetailsDropdownOpened() {
            track("contacts options", "click contacts details", "expand filter");
        },
        trackContactDetailsDropdownClosed() {
            track("contacts options", "collapse contact details DD", "collapse filter");
        },
        trackContactDetailsValueSelected(value: ContactDetail) {
            track("contacts options", "select details option", `click detail/${value}`);
        },
        trackRevealContactClick() {
            track("contacts options", "click reveal", "reveal contact");
        },
        trackExportContactsDDOpen() {
            track("contacts options", "open export DD", "click export");
        },
    };
}
